<template>
  <v-dialog
    ref="dialog"
    v-model="modal"
    persistent
    :disabled="$attrs.readonly"
    :return-value.sync="time"
    :width="width"
    v-bind="dialogProps"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        clearable
        :value="customTextFormat(time)"
        :label="label"
        :prepend-icon="icon"
        :readonly="textFieldReadonly"
        v-bind="{...attrs,...$attrs}"
        v-on="on"
        @click:clear="time = undefined"
      />
    </template>
    <v-time-picker
      v-model="time"
      full-width
      scrollable
      :locale="convertLocale(currentLocale, 'bcp47')"
      v-bind="timePickerProps"
    >
      <v-btn
        text
        color="primary"
        @click="modal = false"
      >
        {{ $t('common.cancel') }}
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="time = undefined"
      >
        {{ $t('common.clear') }}
      </v-btn>
      <v-spacer />
      <v-btn
        color="primary"
        @click="$refs.dialog.save(time)"
      >
        {{ $t('common.ok') }}
      </v-btn>
    </v-time-picker>
  </v-dialog>
</template>

<script>
import moment from 'moment'
export default {
  components: {
  },
  props: {
    value: {
      validator: prop => typeof prop === 'string' || prop === null || prop === undefined,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '300px'
    },
    textFieldReadonly: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'mdi-clock-time-four-outline'
    },
    dialogProps: {
      type: Object,
      default: () => {}
    },
    timePickerProps: {
      type: Object,
      default: () => {}
    },
    customTextFormat: {
      type: Function,
      default: (time) => {
        if (moment(time, 'HH:mm').isValid()) return moment(time, 'HH:mm').format('hh:mm A')
        else return ''
      }
    }
  },
  data () {
    return {
      modal: false,
      time: null
    }
  },
  watch: {
    value: {
      handler (val) {
        this.time = val
      },
      immediate: true
    },
    time (val) {
      this.$emit('input', val)
    }
  }
}
</script>
